import React, { useContext, useMemo } from 'react';
import * as Styles from './IconCrown.styles';
import { ThemeContext } from 'styled-components';

const IconCrown = ({ size, gradient }) => {
  const theme = useContext(ThemeContext);
  const sizes = {
    small: 16,
    medium: 20,
    large: 28,
  };
  const width = sizes[size] || sizes.medium;
  const height = width * 0.7;

  // Map gradient prop to theme gradient value
  const gradientId = gradient ? `crown-gradient-${gradient}` : undefined;
  const gradientDef = useMemo(() => {
    if (!gradient || !theme || !theme.v2 || !theme.v2.colors || !theme.v2.colors.gradient || !theme.v2.colors.gradient[gradient]) return null;
    // Parse the linear-gradient string to extract the colors and stops
    // Ex: linear-gradient(272deg, #0070D1 1.36%, ...)
    const match = theme.v2.colors.gradient[gradient].match(/linear-gradient\(([^,]+),(.+)\)/);
    if (!match) return null;
    const angle = match[1].trim();
    const stops = match[2].split(',').map(s => s.trim());
    // Convert angle to SVG gradient coordinates (approximate)
    let x1 = '0%'; let y1 = '0%'; let x2 = '100%'; let y2 = '0%';
    if (angle.endsWith('deg')) {
      const deg = parseFloat(angle);
      if (deg === 90) { x1 = '0%'; y1 = '0%'; x2 = '100%'; y2 = '0%'; } else if (deg === 272) { x1 = '100%'; y1 = '0%'; x2 = '0%'; y2 = '100%'; } else if (deg === 94) { x1 = '0%'; y1 = '0%'; x2 = '100%'; y2 = '10%'; }
    }
    return (
      <linearGradient id={gradientId} x1={x1} y1={y1} x2={x2} y2={y2}>
        {stops.map((stop) => {
          const parts = stop.split(' ');
          const color = parts[0];
          const offset = parts[1];
          const key = `${color}-${offset || ''}`;
          return <stop key={key} offset={offset || undefined} stopColor={color} />;
        })}
      </linearGradient>
    );
  }, [gradient, theme, gradientId]);

  return (
    <Styles.Svg width={width} height={height} viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="IconCrown">
      {gradientDef && (
        <defs>
          {gradientDef}
        </defs>
      )}
      <path
        d="M13.8013 7.68995L9.6608 0.783203L5.52031 7.68995L0 2.16441L1.38016 13.2155H17.9414L19.3216 2.16441L13.8013 7.68995Z"
        fill={gradientDef ? `url(#${gradientId})` : '#F3F9FF'}
      />
    </Styles.Svg>
  );
};

export default IconCrown;
